import { render, staticRenderFns } from "./DurationInput.vue?vue&type=template&id=a646cca4&scoped=true&lang=pug&"
import script from "./DurationInput.vue?vue&type=script&lang=js&"
export * from "./DurationInput.vue?vue&type=script&lang=js&"
import style0 from "./DurationInput.vue?vue&type=style&index=0&id=a646cca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a646cca4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VIcon,VInput,VRow})
